

<template>
    <div style="margin-top:20px; width:100%;">
        <div class="col-md-12">
            <h3 style="cursor: pointer; user-select: none;" @click="showComments =! showComments">Review Comments <span v-if="!showComments">+</span><span v-if="showComments">-</span></h3>
            <!--<label for="exampleFormControlTextarea2">Reviewer Comment</label>-->
            <textarea v-if="showComments" v-model="newReviewComment.text" class="form-control" id="exampleFormControlTextarea2" rows="3"></textarea>
            <button v-if="showComments" type="submit" class="btn btn-primary" @click="addComment(newReviewComment,area)" style="margin-top: 10px;">Add Comment</button> <br />
        </div>
        <!-- comments -->
        <div v-if="showComments" class="col-md-12">
            <div class="panel panel-default widget">
                <div class="panel-heading">
                    <!--<span class="glyphicon glyphicon-comment"></span>
                    <h3 class="panel-title">
                        Recent Comments
                    </h3>
                    <span class="label label-info">
                        78
                    </span>-->
                </div>
                <div class="panel-body" style="max-height: 400px; overflow-x: hidden; margin-top:10px;">
                    <ul v-for="parentComment in comments" class="list-group">
                        <!-- begin comment -->
                        <li v-if="parentComment.parentCommentId == null" class="list-group-item">
                            <div class="row">
                                <div class="col-xs-12 col-md-12 comment-style">
                                    <div>
                                        <div class="mic-info">
                                            By: {{parentComment.createdBy}} on {{parentComment.createdDate | formatDate}}
                                            <b-form-checkbox v-model="parentComment.isAddressed"
                                                             name="satisfied-checkbox"
                                                             @input="addComment(parentComment,area)">
                                                Satisfied
                                            </b-form-checkbox>
                                        </div>
                                    </div>
                                    <div class="comment-text">
                                        {{parentComment.text}}
                                    </div>
                                    <div class="action">

                                        <div style="cursor: pointer; user-select: none;" @click="parentComment.showReply =! parentComment.showReply">
                                            reply
                                        </div>

                                        <!--<button type="button" class="btn btn-success btn-xs" title="Approved">
                                            <span class="glyphicon glyphicon-ok"></span>
                                        </button>-->
                                        <!--<button type="button" class="btn btn-danger btn-xs" title="Delete">
                                            <span class="glyphicon glyphicon-trash"></span>
                                        </button>-->
                                    </div>
                                </div>

                                <div style="margin-left:50px; width:100%">
                                    <div v-show="parentComment.showReply" class="col-xs-12 col-md-12 comment-style" style="margin-top: 0.5rem;">
                                        <div>
                                            <textarea v-model="parentComment.replyComment.text" class="form-control" id="exampleFormControlTextarea2" rows="2"></textarea>
                                            <button type="submit" class="btn btn-primary" @click="addComment(parentComment.replyComment,area)" style="margin-top: 10px;">Add Comment</button> <br />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </li>
                        <!-- end comment -->
                        <!-- begin child comment -->
                        <li v-for="childComment in comments" v-if="childComment.parentCommentId != null && parentComment.id == childComment.parentCommentId" class="list-group-item">
                            <div class="row">
                                <div style="margin-left:50px; width:100%">
                                    <div class="col-xs-12 col-md-12 comment-style">

                                        <div>
                                            <div class="mic-info">
                                                By: {{childComment.createdBy}} on {{childComment.createdDate | formatDate}}
                                            </div>
                                        </div>
                                        <div class="comment-text">
                                            {{childComment.text}}
                                        </div>
                                        <div class="action">
                                            <div style="cursor: pointer; user-select: none;" @click="childComment.showReply =! childComment.showReply">
                                                reply
                                            </div>


                                            <!--<div style="margin-left:50px; width:100%">
                                                <div v-show="parentComment.showReply" class="col-xs-12 col-md-12 comment-style" style="margin-top: 0.5rem;">
                                                    <div>
                                                        <textarea v-model="parentComment.replyComment.text" class="form-control" id="exampleFormControlTextarea2" rows="2"></textarea>
                                                        <button type="submit" class="btn btn-primary" @click="addComment(parentComment.replyComment)" style="margin-top: 10px;">Add Comment</button> <br />
                                                    </div>
                                                </div>
                                            </div>-->
                                            <!--<button type="button" class="btn btn-primary btn-xs" title="Edit">
                                                <span class="glyphicon glyphicon-pencil"></span>
                                            </button>
                                            <button type="button" class="btn btn-success btn-xs" title="Approved">
                                                <span class="glyphicon glyphicon-ok"></span>
                                            </button>
                                            <button type="button" class="btn btn-danger btn-xs" title="Delete">
                                                <span class="glyphicon glyphicon-trash"></span>
                                            </button>-->
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-left:100px; width:100%">
                                    <div v-show="childComment.showReply" class="col-xs-12 col-md-12 comment-style" style="margin-top: 0.5rem;">
                                        <textarea v-model="childComment.replyComment.text" class="form-control" id="exampleFormControlTextarea2" rows="2"></textarea>
                                        <button type="submit" class="btn btn-primary" @click="addComment(childComment.replyComment,area)" style="margin-top: 10px;">Add Comment</button> <br />
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- end child comment -->
                    </ul>
                </div>
            </div>
        </div>
        <!-- end comments -->
    </div>
</template>

<style scoped>
    .comment-style {
        background-color: #F6F7F8;
        border-radius: 25px;
        padding: 15px;
    }

    .widget .panel-body {
        padding: 0px;
    }

    .widget .list-group {
        margin-bottom: 0;
    }

    .widget .panel-title {
        display: inline
    }

    .widget .label-info {
        float: right;
    }

    .widget li.list-group-item {
        border-radius: 0;
        border: 0;
        padding: 0.5rem 1.25rem;
        /*border-top: 1px solid #ddd;*/
    }
    /*.widget li.list-group-item:hover {
            background-color: rgba(86,61,124,.1);
        }*/
    .widget .mic-info {
        color: #666666;
        font-size: .8rem;
    }

    .widget .action {
        margin-top: 5px;
    }

    .widget .comment-text {
        font-size: 1rem;
    }

    .widget .btn-block {
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }
</style>

<script type="text/babel">
    import ApprovalService from '@/services/ApprovalService'

    export default {
    components: {
    },

    async created() {
    this.comments = await ApprovalService.getAllComments(this.expenseReportID,this.area);
    },

    props: {
    "expenseReportID": {default: null},
    "area":{default:null}
    },
    methods:{
    async addComment(comment,area) {
        try {
                await ApprovalService.addComment(comment,area);
                this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Comments Updated" });
                comment.text = null;
            } catch (e) {
                this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
            }
            
    this.comments = await ApprovalService.getAllComments(this.expenseReportID,this.area);
        }
    },
    data: function () {
    return { comments: null,
    showComments:false,
    newReviewComment: {
    ExpenseReportId: this.$route.params.erid,
    ExpenseReportSectionTypeId: 7,
    Text: null,
    ParentCommentId: null,
    IsAddressed: false,
    isArchived: false
    }
    }
    }
    }
</script>